import React, { useState } from "react";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

export const StarRating = ({ value = 0, onRate, readOnly = false, size = 24 }) => {
  const [hover, setHover] = useState(0);
  const display = hover || value;

  return (
    <div className="flex items-center gap-0.5" role="group" aria-label="Rating out of 10">
      {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          data-testid={`vote-star-${n}`}
          onMouseEnter={() => !readOnly && setHover(n)}
          onMouseLeave={() => !readOnly && setHover(0)}
          onClick={() => !readOnly && onRate?.(n)}
          className={cn(
            "transition-transform duration-150 outline-none focus:outline-none focus-visible:outline-none [-webkit-tap-highlight-color:transparent]",
            !readOnly && "hover:scale-125 cursor-pointer",
            readOnly && "cursor-default"
          )}
          aria-label={`Rate ${n} out of 10`}
        >
          <Star
            style={{ width: size, height: size }}
            className={cn(
              "transition-colors duration-150",
              n <= display ? "fill-primary text-primary" : "fill-transparent text-muted-foreground/40"
            )}
          />
        </button>
      ))}
    </div>
  );
};
